export default function IconFolder({ color = "white" }) {
  return (
    <div className="icon">
      <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none">
        <path d="M0 1H6L9 4H16V14H0V1Z" fill={color} />
      </svg>
    </div>
  );
}
